import { Component, Injector, Input, OnInit, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';
import { AiTextGenerationRequest } from '@app/shared/interfaces/ai-text-generation-request';
import { AIService } from '@app/shared/services/AI.service';
import { CustomAttribute } from '@product/shared/models/AttributeDTO';

@Component({
  selector: 'app-product-field-html',
  templateUrl: './product-field-html.component.html',
  styleUrls: ['./product-field-html.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldHtmlComponent),
      multi: true,
    },
  ],
})
export class ProductFieldHtmlComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor
{
  aiLoading: boolean = false;
  value = '';
  onChange: any = (value: string) => {};
  onTouched: any = () => {};
  ngControl: NgControl | null = null;
  constructor(private injector: Injector, private aiService: AIService) {
    super(injector);
  }
  writeValue(obj: string): void {
    this.value = obj;
    this.onChange(this.value);
  }
  registerOnChange(fn: string): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getNgControl() {
    if (!this.ngControl) {
      this.ngControl = this.injector.get(NgControl, null);
    }
  }
  get parentFormGroup() {
    this.getNgControl(); 
    if (!this.ngControl || !this.ngControl.control) {
      console.error("control is not defind");
      return null; 
    }
    return this.ngControl?.control?.parent as FormGroup;
  }
  config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear',
          ],
        ],
      ],
    },
    height: '200px',
    toolbar: [
      ['misc', ['undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear',
        ],
      ],
      ['fontsize', ['fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'link', 'hr']],
    ],
    codeviewFilter: true,
    codeviewFilterRegex:
      /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true,
    buttons: {},
  };
  getAIText() {
    this.aiLoading = true;
    let question: string = this.field.AdditionalData?.aigenerationQuestion;
    if (question == null) {
      this.message.error("This attribute doesn't have an AI question");
      this.aiLoading = false;
      return;
    }
    const params = this.route.snapshot.params;
    const id = params['id'];
    const request: AiTextGenerationRequest = {
      attributeId: +this.field.Code,
      objectId: +id,
      objectType: 12,
      includedAttributes: {},
      languageId: this.languageId,
    };

    this.aiService
      .getText(request, question, this.parentFormGroup!, this.controlName)
      .then(() => (this.aiLoading = false));
  }
}
